import axios from 'axios';
import { get } from 'lodash';

import * as Constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import { AXIOS_DEFAULT_OPTIONS } from '../';

const init = (dispatch, isLoading = true) =>
  dispatch({
    type: Constants.APP_LOADING,
    isLoading,
  });

 const getCustomValidationErrors = (error) => {
   if(get(error,'response.data.devErrorMessage')) {
    return [{ error: get(error,'response.data.devErrorMessage') }]
   } else {
    return get(error, 'response.data.error.detail.validationErrors') || [error];
   }
};
export const resetApp = () => dispatch => dispatch({ type: Constants.APP_RESET });

export const setAuthSettings = (data) => dispatch =>
  dispatch({
    type: Constants.AUTH_SETTINGS_SET_LDAP_AUTH_DETAILS,
    payload: data,
  });

export const showLoading = isLoading => dispatch => init(dispatch, isLoading);

export const fetchAuthSettingsList = () => async (dispatch, getState) => {
  init(dispatch);
  const config = getConfig(getState());
  const { portal } = config;

  const url = `${portal.hostname}/admin/auth/schemes`;
  await axios.get(url, AXIOS_DEFAULT_OPTIONS)
    .then(response =>
      dispatch({
        type: Constants.AUTH_SETTINGS_GET_LIST_SUCCESS,
        payload: response.data,
      }),
    )
    .catch(error =>
      dispatch({
        type: Constants.AUTH_SETTINGS_GET_LIST_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};


export const updateDefaultAuthSettings = (uuid) => async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const data = {
      defaultConfig: true,
      silent: true,
      uuid,
    };
    const url = `${portal.hostname}/admin/auth/schemes/${uuid}`;
    await axios.patch(url, data, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: Constants.AUTH_SETTINGS_UPDATE_DEFAULT_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: Constants.AUTH_SETTINGS_UPDATE_DEFAULT_ERROR,
          payload: getValidationErrors(error),
        });
      });
};

export const checkProviderNameUnique = (name, uuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/auth/schemes/validate`;
    await axios.get(url,
      {
        params: {
          idpProviderName: `'${name}'`,
          uuid: `'${uuid}'`,
        },
      },
      {
        credentials: 'include',
      })
      .then((response) => {
        dispatch({
          type: Constants.AUTH_SETTINGS_NAME_UNIQUE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: Constants.AUTH_SETTINGS_NAME_UNIQUE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchAuthSchemeDetails = (uuid) => async (dispatch, getState) => {
  init(dispatch);
  const config = getConfig(getState());
  const { portal } = config;

  const url = `${portal.hostname}/admin/auth/schemes/${uuid}`;
  await axios.get(url, AXIOS_DEFAULT_OPTIONS)
    .then(response =>
      dispatch({
        type: Constants.AUTH_SETTINGS_GET_SCHEMA_DETAILS_SUCCESS,
        payload: response.data,
      }),
    )
    .catch(error =>
      dispatch({
        type: Constants.AUTH_SETTINGS_GET_SCHEMA_DETAILS_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const updateAuthScheme = (uuid, data) => async (dispatch, getState) => {
  init(dispatch);
  const config = getConfig(getState());
  const { portal } = config;
  
  const url = `${portal.hostname}/admin/auth/schemes/${uuid}`;
  await axios.put(url, data, AXIOS_DEFAULT_OPTIONS)
    .then(response =>
      dispatch({
        type: Constants.AUTH_SETTINGS_UPDATE_SCHEMA_SUCCESS,
        payload: response.data,
      }),
    )
    .catch(error =>
      dispatch({
        type: Constants.AUTH_SETTINGS_UPDATE_SCHEMA_ERROR,
        payload: getCustomValidationErrors(error),
      }),
    );
};

export const saveAuthScheme = (uuid, data) => async (dispatch, getState) => {
  init(dispatch);
  const config = getConfig(getState());
  const { portal } = config;

  const url = `${portal.hostname}/admin/auth/schemes`;
  await axios.post(url, data, AXIOS_DEFAULT_OPTIONS)
    .then(response =>
      dispatch({
        type: Constants.AUTH_SETTINGS_SAVE_SCHEMA_SUCCESS,
        payload: response.data,
      }),
    )
    .catch(error =>
      dispatch({
        type: Constants.AUTH_SETTINGS_SAVE_SCHEMA_ERROR,
        payload: getCustomValidationErrors(error),
      }),
    );
};

export const deleteAuth = (uuid) =>
  async (dispatch, getState) => {
    init(dispatch);
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/admin/auth/schemes/${uuid}`;
    await axios.delete(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: Constants.AUTH_SETTINGS_DELETE_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: Constants.AUTH_SETTINGS_DELETE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };